module.exports = __webpack_public_path__ + "static/media/avatar-2.034d02d7.jpg";